import { ICellRendererParams } from "@ag-grid-community/core";
import { Box, Center, Stack } from "@chakra-ui/react";
import React from "react";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";
import { MaterialIcon } from "../../shared/MaterialIcon";

interface IProps extends ICellRendererParams {
  meta?: IRegistryDataColumn;
}

export const CellYesNo = (props: IProps) => {
  const elem = React.useMemo(() => {
    if (props.value === "no") {
      return <MaterialIcon color="danger" name="close" variant="outline" />;
    } else if (props.value === "yes") {
      return <MaterialIcon color="success" name="done" variant="outline" />;
    } else {
      return <Box></Box>;
    }
  }, [props.value]);

  return (
    <Stack h="full" px={2} spacing={0} whiteSpace={"pre-wrap"}>
      <Center h="full">{elem}</Center>
    </Stack>
  );
};
